"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = void 0;
const v4_1 = require("zod/v4");
exports.UiConfigSchema = v4_1.z.object({
    description: v4_1.z.string(),
    creditFacilitySlug: v4_1.z.string(),
    useReceivableWaivers: v4_1.z.boolean().optional().describe(`
   * this optional field will determine if calc-agent should use
   * receivable borrowing base test waivers when generating the receivable response tape.
   * If this field is not set, receivable waivers will not be used
    `),
});
exports.nodeType = 'operation_calcAgent';
//# sourceMappingURL=types.js.map